import { render, staticRenderFns } from "./GarageAccreditedList.vue?vue&type=template&id=621d7c81"
import script from "./GarageAccreditedList.vue?vue&type=script&lang=js"
export * from "./GarageAccreditedList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports